import React, { useRef, useState } from 'react';
import { Button, Divider, Form, Input, InputRef, Select, Space } from 'antd';

const SelectExpiresDay = () => {
  const inputRef = useRef<InputRef>(null);
  const [newExpirDaysItems, setNewExpirDaysItems] = useState('');
  const [expirItems, setExpirItems] = useState<any>(['30', '60', '90', '365']);

  const onExpirDaysItems = (event: React.ChangeEvent<HTMLInputElement>) => {
    setNewExpirDaysItems(event.target.value);
  };

  const addItem = (e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => {
    e.preventDefault();
    if (!newExpirDaysItems) {
      return;
    }
    expirItems.unshift(newExpirDaysItems);
    setExpirItems([...expirItems]);
    setNewExpirDaysItems('');
  };

  return (
    <Form.Item
      name='expiresDate'
      label='Expires Date (Choose days)'
      rules={[
        {
          required: true,
          message: 'Expires Date is requied',
        },
      ]}
    >
      <Select
        placeholder='Select Days'
        size='large'
        dropdownRender={(menu) => (
          <>
            {menu}
            <Divider style={{ margin: '8px 0' }} />
            <Space style={{ padding: '0 8px 4px', textAlign: 'center' }}>
              <Input
                size='large'
                placeholder='Please enter item'
                ref={inputRef}
                value={newExpirDaysItems}
                onChange={onExpirDaysItems}
                onKeyDown={(event) => {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
              />
              <Button className='btn-info' type='text' size='large' onClick={addItem}>
                <i className='fas fa-plus mr-2'></i>Add item
              </Button>
            </Space>
          </>
        )}
      >
        {expirItems?.map((item: any) => (
          <Select.Option key={item} value={item} label={item}>
            {item}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  );
};

export default SelectExpiresDay;
